var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWires(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .wire {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2, 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "wire",
    d: "M26.15,0c-8.07,4.3-13.616,3-17.262,2.029s-8.888,0-8.888,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wire",
    d: "M0,16.086c8.069,4.3,13.616,3,17.262,2.029s8.89,0,8.89,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wire",
    d: "M27.15,8.662c-8.07-4.3-13.616-3-17.262-2.029s-8.89,0-8.89,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWires);
export default __webpack_public_path__ + "static/media/wires.de71a7f8e03d65f4e45a0850891d7af4.svg";
export { ForwardRef as ReactComponent };